import { ConfigurationDetailFeatures } from '../config/resources/configuration.resource';

/**
 * Whether this instance offers the ArrivalBoard: it needs the AmbER stack (`amberGateway`, read-only and derived
 * from the backend env `AMBER_GATEWAY_ENABLED`) and the tenant's opt-in (`arrivalBoard`). The one place the kiosk
 * route's guard and the configuration page decide it, so the two cannot drift apart.
 */
export function isArrivalBoardEnabled(features: ConfigurationDetailFeatures | undefined): boolean {
    return !!features?.amberGateway?.enabled && !!features?.arrivalBoard?.enabled;
}
